import React, { useState } from 'react';
import { Send, Loader } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const Contact = ({ t }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: ''
  });
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');
    try {
      const res = await fetch(`${BACKEND_URL}/api/homepage/consultation`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (res.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', company: '', phone: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    } finally {
      setLoading(false);
      setTimeout(() => setStatus(''), 5000);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="contact-wrapper">
          <div className="contact-info">
            <h2 className="heading-1">{t.contact.title}</h2>
            <p className="body-large text-secondary">{t.contact.subtitle}</p>
          </div>
          
          <form onSubmit={handleSubmit} className="contact-form" data-testid="consultation-form">
            <div className="form-row">
              <div className="form-group">
                <label className="body-small">{t.contact.form.name}</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="form-input"
                  data-testid="contact-name-input"
                />
              </div>
              
              <div className="form-group">
                <label className="body-small">{t.contact.form.email}</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-input"
                  data-testid="contact-email-input"
                />
              </div>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label className="body-small">{t.contact.form.company}</label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  required
                  className="form-input"
                  data-testid="contact-company-input"
                />
              </div>
              
              <div className="form-group">
                <label className="body-small">{t.contact.form.phone}</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="form-input"
                  data-testid="contact-phone-input"
                />
              </div>
            </div>
            
            <div className="form-group">
              <label className="body-small">{t.contact.form.message}</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="4"
                className="form-input"
                data-testid="contact-message-input"
              />
            </div>
            
            <button type="submit" className="btn-primary submit-btn" disabled={loading} data-testid="contact-submit-btn">
              {loading ? <Loader size={16} className="spin" /> : <Send size={16} />}
              {t.contact.form.submit}
            </button>
            
            {status === 'success' && (
              <div className="form-success" data-testid="contact-success-msg">{t.contact.form.success}</div>
            )}
            {status === 'error' && (
              <div className="form-error" data-testid="contact-error-msg">{t.contact.form.error}</div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
